export enum ProgramPaths {
    ofispro = "/ofispro",
    icrapro = "/icrapro",
    eicrapro = "/eicrapro",
    davapro = "/davapro",
    arabulucupro = "/arabulucupro",
    giris = "/giris",
    erisimYok = "/erisim-yok"
}